// Convert a decimal to a percentage, preserving N decimal places
export const toPercentage = (decimal: number, n = 2): number => {
    return Number((decimal * 100).toFixed(n));
};

// Convert a decimal to a percentage string, preserving N decimal places, trimming trailing zeros
export const toPercentageStr = (decimal: number, n = 2): string => {
    return `${(decimal * 100).toFixed(n).replace(/\.0+$/, '')}%`;
};
